<template>
	<div :class="classes">
		<div class="loading-inner">
			<div class="loading2" v-if="text !== ''" v-html="text" />
			<div class="logo" v-if="showLogo"></div>
			<div class="loading3"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Loading",
	props: {
		text: {
			type: String,
			default: ""
		},
		position: {
			type: String,
			default: "full"
		},
		showLogo: {
			type: Boolean,
			default: false
		}
	},
	methods: {},
	computed: {
		classes() {
			let classes = { loading: true };
			if (this.position !== "") {
				classes[this.position] = true;
			}
			return classes;
		}
	},
	data() {
		return {};
	}
};
</script>
<style lang="less" scoped>
@import "./../assets/css/less/_helper.less";
@import "./../assets/css/less/_settings.less";
.loading {
	.vertical-align-parent;
	z-index: 4;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	position: absolute;
	background-color: rgba(255, 255, 255, 0.95);

	&.full {
		position: fixed;
		z-index: 999;
	}

	&.internal {
		position: relative;
		min-height: 34px;
	}

	.loading-inner {
		.vertical-align;
		width: 100%;

		.logo {
			background: url(./../assets/img/rank-caddy-logo.svg) center center
				no-repeat;
			background-size: 200px auto;
			width: 200px;
			height: 32px;
			margin: 0 auto 5px;
		}

		.loading2 {
			text-align: center;
			margin: 0 auto;
			font-size: 12px;
		}
		.loading3 {
			background: url(./../assets/img/loader.svg) center center no-repeat;
			width: 60px;
			height: 30px;
			background-size: 100% auto;
			margin: 0 auto;
		}

		p {
			color: @formDefaultColour;
			margin: 15px auto;
			text-align: center;
		}

		.lds-css {
			width: 110px;
			height: 110px;
			display: block;
			margin: 0 auto;
			overflow: hidden;

			.lds-spinner {
				position: relative;
				left: -45px;
				top: -45px;
				width: 200px !important;
				height: 200px !important;
				-webkit-transform: translate(-100px, -100px) scale(1)
					translate(100px, 100px);
				transform: translate(-100px, -100px) scale(1)
					translate(100px, 100px);

				div {
					left: 94px;
					top: 48px;
					position: absolute;
					-webkit-animation: lds-spinner linear 1s infinite;
					animation: lds-spinner linear 1s infinite;
					background: @formDefaultColour;
					width: 12px;
					height: 24px;
					border-radius: 40%;
					-webkit-transform-origin: 6px 52px;
					transform-origin: 6px 52px;

					&:nth-child(1) {
						-webkit-transform: rotate(0deg);
						transform: rotate(0deg);
						-webkit-animation-delay: -0.916666666666667s;
						animation-delay: -0.916666666666667s;
					}

					&:nth-child(2) {
						-webkit-transform: rotate(30deg);
						transform: rotate(30deg);
						-webkit-animation-delay: -0.833333333333333s;
						animation-delay: -0.833333333333333s;
					}

					&:nth-child(3) {
						-webkit-transform: rotate(60deg);
						transform: rotate(60deg);
						-webkit-animation-delay: -0.75s;
						animation-delay: -0.75s;
					}

					&:nth-child(4) {
						-webkit-transform: rotate(90deg);
						transform: rotate(90deg);
						-webkit-animation-delay: -0.666666666666667s;
						animation-delay: -0.666666666666667s;
					}

					&:nth-child(5) {
						-webkit-transform: rotate(120deg);
						transform: rotate(120deg);
						-webkit-animation-delay: -0.583333333333333s;
						animation-delay: -0.583333333333333s;
					}

					&:nth-child(6) {
						-webkit-transform: rotate(150deg);
						transform: rotate(150deg);
						-webkit-animation-delay: -0.5s;
						animation-delay: -0.5s;
					}

					&:nth-child(7) {
						-webkit-transform: rotate(180deg);
						transform: rotate(180deg);
						-webkit-animation-delay: -0.416666666666667s;
						animation-delay: -0.416666666666667s;
					}

					&:nth-child(8) {
						-webkit-transform: rotate(210deg);
						transform: rotate(210deg);
						-webkit-animation-delay: -0.333333333333333s;
						animation-delay: -0.333333333333333s;
					}

					&:nth-child(9) {
						-webkit-transform: rotate(240deg);
						transform: rotate(240deg);
						-webkit-animation-delay: -0.25s;
						animation-delay: -0.25s;
					}

					&:nth-child(10) {
						-webkit-transform: rotate(270deg);
						transform: rotate(270deg);
						-webkit-animation-delay: -0.166666666666667s;
						animation-delay: -0.166666666666667s;
					}

					&:nth-child(11) {
						-webkit-transform: rotate(300deg);
						transform: rotate(300deg);
						-webkit-animation-delay: -0.083333333333333s;
						animation-delay: -0.083333333333333s;
					}

					&:nth-child(12) {
						-webkit-transform: rotate(330deg);
						transform: rotate(330deg);
						-webkit-animation-delay: 0s;
						animation-delay: 0s;
					}
				}
			}
		}
	}
}

@keyframes lds-spinner {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
@-webkit-keyframes lds-spinner {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>
